class ComprehensiveCartRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    try {
      const cartItemsString = this.dataset.cartItems.replace(/&quot;/g, '"');
      this.cartItems = JSON.parse(cartItemsString);
      this.combinedCartItems = this.combineVariants(this.cartItems);
      this.productsToShow = parseInt(this.dataset.productsToShow, 10) || 3;
    } catch (e) {
      this.cartItems = [];
      this.combinedCartItems = [];
      this.productsToShow = 3;
    }

    if (this.combinedCartItems.length > 0) {
      this.loadRecommendations();
    }
  }

  combineVariants(cartItems) {
    const combinedItems = {};
    cartItems.forEach(item => {
      const productId = item.product_id;
      if (combinedItems[productId]) {
        combinedItems[productId].quantity += item.quantity;
      } else {
        combinedItems[productId] = { ...item };
      }
    });
    return Object.values(combinedItems);
  }

  loadRecommendations() {
    const productIds = this.combinedCartItems.map(item => item.product_id);
    const recommendationPromises = productIds.map(id => this.fetchRecommendationsForProduct(id));

    Promise.all(recommendationPromises)
      .then(allRecommendations => {
        const processedRecommendations = this.processRecommendations(allRecommendations, productIds);
        this.renderRecommendations(processedRecommendations);
      })
      .catch(error => {
        console.error('Error loading recommendations:', error);
      });
  }

  async fetchRecommendationsForProduct(productId) {
    const url = `${this.dataset.url}&product_id=${productId}&section_id=${this.dataset.sectionId}`;
    try {
      const response = await fetch(url);
      const text = await response.text();
      const html = document.createElement('div');
      html.innerHTML = text;
      const productCards = html.querySelectorAll('.cart-drawer__recommendations .grid__item');
      return Array.from(productCards).map(card => this.extractProductData(card));
    } catch (error) {
      console.error(`Error fetching recommendations for product ${productId}:`, error);
      return [];
    }
  }

  extractProductData(card) {
    const productInfoElement = card.querySelector('product-info-cart-upsell');
    if (productInfoElement) {
      return {
        id: productInfoElement.dataset.productId,
        element: card.cloneNode(true)
      };
    }
    return null;
  }

  processRecommendations(allRecommendations, sourceProductIds) {
    // Deduplicate: keep first occurrence of each product, preserving order
    const seen = new Set();
    const deduped = [];

    allRecommendations.forEach(recommendations => {
      recommendations.forEach(rec => {
        if (!rec || seen.has(rec.id)) return;
        seen.add(rec.id);
        deduped.push(rec);
      });
    });

    return deduped;
  }

  renderRecommendations(recommendations) {
    const limited = recommendations.slice(0, this.productsToShow);

    const container = document.createElement('div');
    container.className = 'product-recommendations no-markers';

    limited.forEach(item => {
      if (item && item.element) {
        container.appendChild(item.element);
      }
    });

    this.innerHTML = '';
    this.appendChild(container);

    const recommendationsContainer = this.closest('.cart-drawer__recommendations');
    if (recommendationsContainer) {
      if (limited.length > 0) {
        recommendationsContainer.classList.add('has-recommendations');
      } else {
        recommendationsContainer.classList.remove('has-recommendations');
      }
    }

    if (limited.length > 0) {
      this.classList.add('product-recommendations--loaded');
    } else {
      this.classList.remove('product-recommendations--loaded');
    }

    setTimeout(() => {
      this.dispatchEvent(new CustomEvent('cart-recommendations-rendered', { bubbles: true }));
    }, 0);
  }
}

customElements.define('comprehensive-cart-recommendations', ComprehensiveCartRecommendations);

class ProductInfoCartUpsell {
  static instance = null;

  constructor() {
    if (ProductInfoCartUpsell.instance) {
      return ProductInfoCartUpsell.instance;
    }
    ProductInfoCartUpsell.instance = this;

    this.handleRecommendationsRendered = this.handleRecommendationsRendered.bind(this);
    this.initialize();
  }

  initialize() {
    this.container = document.querySelector('.cart-drawer__recommendations');
    if (!this.container) return;
    this.initProductElements();
    this.addEventListeners();
  }

  addEventListeners() {
    document.addEventListener('cart-recommendations-rendered', this.handleRecommendationsRendered);
  }

  handleRecommendationsRendered() {
    this.initialize();
  }

  initProductElements() {
    this.productElements = this.container.querySelectorAll('.cart-upsell-item');
    this.productElements.forEach(productElement => {
      this.initializeProductHandlers(productElement);
    });
  }

  initializeProductHandlers(productElement) {
    const productForm = productElement.querySelector('product-form');
    if (productForm) {
      productForm.addEventListener('submit', this.handleAddToCart.bind(this, productElement));
    }
  }

  handleAddToCart(productElement, event) {
    document.addEventListener('cart:update', () => {
      // Handle any additional actions after cart update
    }, { once: true });
  }
}

new ProductInfoCartUpsell();